import { useSuspenseQuery } from "@apollo/client";

import { MapEditorFeatureOtherPanelDocument } from "./queries.generated";

export function useSuspenseOtherFeatureQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorFeatureOtherPanelDocument, {
        variables: { mapEditorFeatureId },
    });
}
